var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ControlOption',{attrs:{"campos":_vm.campos,"camposIndex":_vm.camposIndex}},[_c('div',{staticClass:"text-center titlesdark--text"},[_c('h3',[_c('span',[_vm._v(_vm._s((_vm.campos.pregunta=='Sin Pregunta' ? 'SIN NOMBRE GRUPO' : _vm.campos.pregunta)))])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }